<script>
import { mapGetters } from 'vuex';

// "Aoikumo integration" filter for the Services / Staff / Branches lists.
// v-model holds the selected integration_id, or null for All. Hidden when the
// account has no Aoikumo integration.
export default {
  name: 'AoikumoIntegrationFilter',
  props: {
    value: { type: Number, default: null },
    // Drop the select's bottom margin, for filter bars whose other selects have none.
    compact: { type: Boolean, default: false },
  },
  emits: ['input'],
  computed: {
    ...mapGetters({ integrations: 'aoikumo/getIntegrations' }),
    selected: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  watch: {
    // The selected integration was removed: fall back to All.
    integrations(list) {
      if (
        this.value !== null &&
        !list.some(item => item.integration_id === this.value)
      ) {
        this.$emit('input', null);
      }
    },
  },
};
</script>

<template>
  <div v-if="integrations.length" class="flex-1">
    <label class="text-sm">
      {{ $t('AOIKUMO_INTEGRATION_FILTER.LABEL') }}
    </label>
    <select
      v-model="selected"
      :class="{ 'mb-0': compact }"
      data-testid="aoikumo-integration-filter"
    >
      <option :value="null">
        {{ $t('AOIKUMO_INTEGRATION_FILTER.ALL') }}
      </option>
      <option
        v-for="item in integrations"
        :key="item.integration_id"
        :value="item.integration_id"
      >
        {{ item.name }}
      </option>
    </select>
  </div>
</template>
